import { render } from "./Regex.vue?vue&type=template&id=32b8e937&scoped=true&ts=true"
import script from "./Regex.vue?vue&type=script&lang=ts"
export * from "./Regex.vue?vue&type=script&lang=ts"

import "./Regex.vue?vue&type=style&index=0&id=32b8e937&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b8e937"]])

export default __exports__